import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-94" data-mp="3gfitoga0y7d2">
      <div className="mx-auto max-w-5xl text-center" data-id="element-95" data-mp="3ghc0pwojutll">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-96" data-mp="32ovukn0cqfgg">
          ACCOUNTING READY™
        </p>
        <nav aria-label="Footer" data-id="element-97" data-mp="36ppivhhphw9v">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-98" data-mp="3ufa3s5xf73ls">
            {links.map(link => <li key={link} data-id="element-99" data-mp="37xwqjq946jl">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-100" data-mp="3lec9wggp4cgx">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-101" data-mp="29xm1qrsppako">
          © 2026 ACCOUNTING READY™. All rights reserved.
        </p>
      </div>
    </footer>;
}